import React from "react";

interface Props {
  type: server.dto.ExternalCalendarTypes
}

export const ExternalCalendarType = (props: Props) => {
  if (props.type === "googleCalendar") {
    return <>Google calendar</>;
  } else if (props.type === "iCalendar") {
    return <>ICalendar</>;
  }

  return null;
}